import { recordMapper } from "./record";

export const createRecordMapper = recordMapper;
